// Lightweight static background — no animations or blur filters (keeps scrolling smooth).
export const BackgroundFX = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-white" aria-hidden="true">
      <div className="absolute inset-0 grid-bg [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
      <div
        className="absolute left-1/2 top-0 h-[600px] w-[900px] -translate-x-1/2"
        style={{ background: "radial-gradient(ellipse at top, rgba(37,99,235,0.07), transparent 60%)" }}
      />
      <div
        className="absolute bottom-0 right-0 h-[500px] w-[600px]"
        style={{ background: "radial-gradient(circle at bottom right, rgba(100,116,139,0.08), transparent 60%)" }}
      />
    </div>
  );
};

export default BackgroundFX;
